import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, background: '#0e2540', color: '#fff', textAlign: 'center' }}>
      <Helmet>
        <title>Página no encontrada | Devssoft</title>
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      <div>
        <p style={{ color: '#ef7d57', fontWeight: 700 }}>ERROR 404</p>
        <h1>Esta página no existe</h1>
        <p>Revisa la dirección o vuelve al sitio principal de Devssoft.</p>
        <Link to="/" style={{ display: 'inline-block', marginTop: 18, padding: '12px 18px', background: '#ef7d57', color: '#071626', fontWeight: 700, textDecoration: 'none' }}>
          Volver al inicio
        </Link>
      </div>
    </main>
  );
}
